import {
  CError,
} from '../consoleMixin'
import {
  getAxiosClient,
} from './axios-client'


/**
 * @typedef {import('./js-doc').V2UpdateBrokerFactoringConfigRequest} V2UpdateBrokerFactoringConfigRequest
 * @typedef {import('./js-doc').V2BrokerFactoringConfigResponse} V2BrokerFactoringConfigResponse
 */

class Broker {
  constructor () {
    this.baseURL = 'brokers'
  }

  /**
   * @param {string} id  - broker ID
   * @param {V2UpdateBrokerFactoringConfigRequest} payload - payload
   * @returns {Promise<V2BrokerFactoringConfigResponse>}
   */
  async updateConfiguration (id, payload) {
    try {
      const result = await (await getAxiosClient(this.baseURL)).patch(id, payload)
      return result?.data
    }
    catch (error) {
      CError('Could not update broker config in V2 API', error)
      throw error
    }
  }
}

export default Broker
